import React, { createContext, useContext } from 'react';
import { z } from 'zod';
import { buildBlockComponent, buildBlockConfigurationDictionary, buildBlockConfigurationSchema, } from '../../document-core/index';
import ColumnsContainerPropsSchema from '../blocks/ColumnsContainer/ColumnsContainerPropsSchema';
import ColumnsContainerReader from '../blocks/ColumnsContainer/ColumnsContainerReader';
import { ContainerPropsSchema } from '../blocks/Container/ContainerPropsSchema';
import ContainerReader from '../blocks/Container/ContainerReader';
import { EmailLayoutPropsSchema } from '../blocks/EmailLayout/EmailLayoutPropsSchema';
import EmailLayoutReader from '../blocks/EmailLayout/EmailLayoutReader';
const ReaderContext = createContext({});
function useReaderDocument() {
    return useContext(ReaderContext);
}
import BLOCKS from '../../blocks';
const READER_DICTIONARY = buildBlockConfigurationDictionary(Object.assign({ ColumnsContainer: {
        schema: ColumnsContainerPropsSchema,
        Component: ColumnsContainerReader,
    }, Container: {
        schema: ContainerPropsSchema,
        Component: ContainerReader,
    }, EmailLayout: {
        schema: EmailLayoutPropsSchema,
        Component: EmailLayoutReader,
    } }, BLOCKS
    .filter((b) => !['ColumnsContainer', 'Container', 'EmailLayout'].includes(b.type))
    .reduce((acc, b) => {
    acc[b.type] = {
        schema: b.schema,
        Component: b.Component,
    };
    return acc;
}, {})));
export const ReaderBlockSchema = buildBlockConfigurationSchema(READER_DICTIONARY);
export const ReaderDocumentSchema = z.record(z.string(), ReaderBlockSchema);
const BaseReaderBlock = buildBlockComponent(READER_DICTIONARY);
export function ReaderBlock({ id }) {
    const document = useReaderDocument();
    return React.createElement(BaseReaderBlock, Object.assign({}, document[id]));
}
export default function Reader({ document, rootBlockId }) {
    return (React.createElement(ReaderContext.Provider, { value: document },
        React.createElement(ReaderBlock, { id: rootBlockId })));
}
//# sourceMappingURL=core.js.map